import env from '@lib/constants/env';
import LINKS from '@lib/constants/links';
import ROUTES from '@lib/constants/routes';
import { ArticleJsonLd, BreadcrumbJsonLd, NextSeo } from 'next-seo';
import { RichText } from 'prismic-reactjs';
import React from 'react';
import { Post } from 'types/frontEndTypes';

const BlogPostSEO = ({ post }: { post: Post }) => {
  const url = `${env.baseUrl + ROUTES.blog}/${post.uid}`;

  const title = post.data.meta_title || RichText.asText(post.data.title);
  return (
    <>
      <BreadcrumbJsonLd
        itemListElements={[
          {
            position: 1,
            name: 'Luna',
            item: env.baseUrl,
          },
          {
            position: 2,
            name: 'Blog',
            item: env.baseUrl + ROUTES.blog,
          },
          {
            position: 3,
            name: title,
            item: url,
          },
        ]}
      />
      <ArticleJsonLd
        url={url}
        title={title}
        images={[post.data.image.url || '']}
        datePublished={post.first_publication_date || ''}
        dateModified={post.last_publication_date || ''}
        authorName={['Time da Luna']}
        publisherName="Luna"
        publisherLogo={LINKS.logo}
        description={post.data.description}
      />
      <NextSeo
        title={title}
        description={post.data.description}
        openGraph={{
          title,
          description: post.data.description,
          url,
          type: 'article',
          article: {
            publishedTime: post.first_publication_date || '',
            modifiedTime: post.last_publication_date || '',
            authors: [LINKS.facebook],
            tags: post.data.categories.map((cat) => cat?.category?.uid || ''),
          },
          images: post.data.image.url
            ? [
              {
                url: post.data.image.url,
                alt: post.data.image.alt,
                width: 1200,
                height: 628,
              },
            ]
            : [],
        }}
      />
    </>
  );
};

export default BlogPostSEO;
